import * as types from './mutation-types';
import { SEARCH_PARAMS, PAGING_INFO, DETAIL_FORM, POPUP_SEARCH_PARAMS } from './state';

export default {
	[types.STATE_INIT]: state => {
		/**버튼 권한 관리 */
		state.isPqyAdmin = false;
		state.isPqyManager = false;
		state.isPqyStaff = false;
		state.isPqyGuest = false;

		state.isSaved = false;
		state.resultList = [];
		state.pagingInfo = PAGING_INFO();
		state.detailForm = DETAIL_FORM();
		state.searchParams = SEARCH_PARAMS();

		/**eo4m 상세 팝업 검색 */
		state.popupSearchParams = POPUP_SEARCH_PARAMS();
		state.rmkHistory = [];

		/**selectBox */
		state.isirCsetScnCd = [];
		state.partGCdList = [];
		state.pgsStEmCdList = [];
		state.vrfRsltCdList = [];
		state.altrTypeCdList = [];
		state.partClCdList = [];
		state.commCodeList = [];
		state.sndStCdList = [];
		state.altrLgrpList = [];
		state.altrSgrpList = [];

		/**eo4m 찾기 팝업 */
		state.findPopupResultList = [];
		state.findPopupSearchParams = SEARCH_PARAMS();
		state.findPopupPagingInfo = PAGING_INFO();

		/**이메일 관련 */
		state.rcptInfo = new Map();
		state.rfpInfo = new Map();
	},
	[types.POPUP_INIT]: state => {
		state.isSaved = false;
		state.detailForm = DETAIL_FORM();
		state.rmkHistory = [];
		state.rfpInfo = new Map();
		state.rcptInfo = new Map();
		state.detailForm.altrPreFile = {};
		state.detailForm.altrPreFileDb = {};
		state.detailForm.altrAftFile = {};
		state.detailForm.altrAftFileDb = {};
	},
	[types.FIND_POPUP_INIT]: state => {
		/**eo4m 찾기 팝업 */
		state.findPopupResultList = [];
		state.findPopupSearchParams = SEARCH_PARAMS();
		state.findPopupPagingInfo = PAGING_INFO();
	},
	[types.DEFAULT_ASSIGN]: (state, { key, value }) => {
		state[key] = value;
	},
	[types.SEARCH_PARAM]: (state, { key, value }) => {
		state.searchParams[key] = value;
	},
	[types.PAGING_INFO]: (state, { key, value }) => {
		state.pagingInfo[key] = value;
	},
	[types.DETAIL_FORM]: (state, { key, value }) => {
		state.detailForm[key] = value;
	},
	[types.POPUP_SEARCH_PARAMS]: (state, { key, value }) => {
		state.popupSearchParams[key] = value;
	},
	[types.FIND_POPUP_SEARCH_PARAMS]: (state, { key, value }) => {
		state.findPopupSearchParams[key] = value;
	},
	[types.FIND_POPUP_PAGING_INFO]: (state, { key, value }) => {
		state.findPopupPagingInfo[key] = value;
	}
};
